import React from 'react'
import BaseComponent from './BaseContainer'
import {Query} from 'react-apollo'
import getPassportFideliteSubscribers from '../apollo/graphql/passportfidelite-subscriber/get'
import {Loader, Message, Dimmer, Statistic, Segment, Header, Grid} from 'semantic-ui-react'
import {withApollo} from 'react-apollo/index'
import Chart from 'react-apexcharts'
import { isWithinInterval } from 'date-fns'

class PassportFideliteStatisticsContainer extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {
      pieCharts: {
        options: {
          labels: ['1 fois', '2 fois', '3 fois', '4 fois', '5 fois et +']
        },
      },
      columnCharts: {
        options: {
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          fill: {
            opacity: 1
          },
        }
      }

    }
  }

  getCount_ (data) {
    const totalCount = [];
    [...Array(5).keys()].map(value => {
      if (value === 4) {
        totalCount.push(data.filter(el => el.count >= value + 1).length)
      } else {
        totalCount.push(data.filter(el => el.count === value + 1).length)
      }
    })
    return totalCount
  }

  getDetail_ (data) {
    const currentYear = new Date().getFullYear()
    const total = []
    const first = []
    const old = [];
    // Loop over all mounth
    [...Array(12).keys()].map(value => {
      const currentMonth = value
      const dayInMonth = new Date(currentYear, currentMonth, 0).getDate()
      const allDataMounth = data.filter(el => isWithinInterval(new Date(el.updated_at), {
        start: new Date(currentYear, currentMonth, 1),
        end: new Date(currentYear, currentMonth, dayInMonth),
      }))
      total.push(allDataMounth.length)
      first.push(allDataMounth.filter(el => el.count === 1).length)
      old.push(allDataMounth.filter(el => el.count > 1).length)
    })

    return [{
      name: 'Total des inscrits',
      data: total
    }, {
      name: 'Nouveaux inscrits',
      data: first
    }, {
      name: 'Réinscrits',
      data: old
    }]

  }



  render () {
    return (
      <Query query={getPassportFideliteSubscribers} fetchPolicy='network-only'>
        {({ data, error, loading }) => {
          if (loading) {
            return (
              <Dimmer active inverted>
                <Loader inverted>Chargement</Loader>
              </Dimmer>
            )
          }
          if (error) {
            return (
              <Message negative>
                <Message.Header>Erreur</Message.Header>
                <p>{error.message}</p>
              </Message>
            )
          }

          const { getPassportFideliteSubscribers } = data
          return (
            <React.Fragment>
              <Grid centered >
                <Grid.Column floated='left'  width={3}>
                  <Segment>
                    <Statistic>
                      <Statistic.Value>{getPassportFideliteSubscribers.length}</Statistic.Value>
                      <Statistic.Label>Nombre total d'inscrits</Statistic.Label>
                    </Statistic>
                  </Segment>
                </Grid.Column>
                <Grid.Column floated='right' width={13}>
                  <Segment className="donut">
                    <Header size='large'>Nombre de réinscriptions</Header>
                    <Chart options={this.state.pieCharts.options} series={this.getCount_(getPassportFideliteSubscribers)} type="donut" width="380" />
                  </Segment>
                </Grid.Column>
              </Grid>
              <Segment className="donut">
                <Header size='large'>Statistiques de l'année en cours</Header>
                <Chart options={this.state.columnCharts.options} type="bar" series={this.getDetail_(getPassportFideliteSubscribers)}/>
              </Segment>
            </React.Fragment>
          )
        }}
      </Query>
    )
  }
}


export default withApollo(PassportFideliteStatisticsContainer)



// WEBPACK FOOTER //
// ./src/containers/PassportFideliteStatisticsContainer.js